const API_URL = process.env.REACT_APP_API_URL;

const STORE = API_URL + "/Store";
const VSTS = STORE + "/VSTS"
const VSTT = STORE + "/VSTT"

export const StoreApiUrl = {
    VSTS_BASE_SUBSCRIPTION_CHECK: VSTS + "/BaseSubscriptionCheck",
    VSTS_FUTURE_SUBSCRIPTION_CHECK: VSTS + "/FutureSubscriptionCheck",
    VSTS_ACTIVE_SUBSCRIPTION_CHECK: VSTS + "/ActiveSubscriptionCheck",
    VSTS_PRODUCT_PRICING: VSTS + "/ProductPricing/{0}",
    VSTT_ACTIVE_PRODUCTS_CHECK: VSTT + "/ActiveProductsCheck",
    VSTT_PRODUCT_PRICING: VSTT + "/ProductPricing",
    PLACE_ORDER: STORE + "/PlaceOrder"
}